// CtaOptionsContainer.tsx
import { styled } from '@mui/material/styles';

export const CtaOptionsContainer = styled('div')`
  max-width: 275px;

  p {
    margin: 1em 0 10px;
  }

  @media (max-width: 767.9px) {
    max-width: 100%;
  }
`;
